

















import mixins from 'vue-typed-mixins'
import DialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'
import i18n from '@/i18n'

import type { DialogOptions } from 'vuejs-dialog/types'

interface Data {
  yesLabel: string
  noLabel: string
}

interface Computed {
  icon?: string
  buttonClass: string
}

interface Props {
  options?: DialogOptions
}

export default mixins(DialogMixin).extend<Data, {}, Computed, Props>({
  data() {
    return {
      yesLabel: this.options?.okText || i18n.tc('common.yes'),
      noLabel: this.options?.cancelText || i18n.tc('common.no'),
    }
  },
  computed: {
    icon(): string | undefined {
      switch (this.options?.type) {
        case 'danger':
          return require('@/assets/svg/warning.svg')
        default:
          return
      }
    },
    buttonClass(): string {
      switch (this.options?.type) {
        case 'danger':
          return '-red'
        default:
          return '-purple'
      }
    }
  }
})
